'use strict';

module.exports = function() {
    var $window = $(window);
    var $home = $("#home");
    var durationEnd = $home.height() - $window.height();

    var controller = new window.ScrollMagic.Controller();

    var elems = [
        {
            id: '#phone',
            offset: Math.round(durationEnd * .031969), //25
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '-116px',
                left: '-31px',
            }
        },
        {
            id: '#paper-clip-1',
            offset: Math.round(durationEnd * .1279), //100
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '135px',
                left: '-75px',
            }
        },
        {
            id: '#paper-clip-2',
            offset: 200,
            duration: 75,
            css: {
                top: '74px',
                left: '-112px',
            }
        },
        {
            id: '#highlighter',
            offset: 380,
            duration: 150,
            css: {
                top: '74px',
                left: '162px',
            }
        },
        {
            id: '#cd',
            offset: 270,
            duration: 150,
            css: {
                top: '-150px',
                left: '300px',
            }
        },
        {
            id: '#pencil-1',
            offset: 600,
            duration: 75,
            css: {
                top: '-10px',
                left: '620px',
            }
        },
        {
            id: '#coffee',
            offset: 35,
            duration: 125,
            css: {
                top: '-65px',
                right: '-190px',
            }
        },
        // {
        //     id: '#cable',
        //     offset: 25,
        //     duration: durationEnd,
        //     css: {
        //         top: '-350px',
        //         right: '-130px',
        //     }
        // },
        {
            id: '#cable-cover',
            offset: 550,
            duration: 150, //100
            css: {
                width: '0px',
            }
        },
        {
            id: '#monitor',
            offset: 275,
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '130px',
                right: '-240px',
            }
        },
        {
            id: '#pen',
            offset: 590,
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '335px',
                right: '-240px',
            }
        },
        {
            id: '#scissor',
            offset: 500,
            duration: 75,
            css: {
                top: '385px',
                right: '-240px',
            }
        },
        {
            id: '#keyboard',
            offset: 400,
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '470px',
                right: '-280px',
            }
        },
        {
            id: '#paper',
            offset: 175,
            duration: 140,
            css: {
                top: '350px',
                left: '-280px',
            }
        },
        {
            id: '#envelope',
            offset: 300,
            duration: Math.round(durationEnd * .1279), //100
            css: {
                top: '359px',
                left: '-251px',
            }
        },
        {
            id: '#ruler',
            offset: 400,
            duration: 50,
            css: {
                top: '650px',
                left: '-110px',
            }
        },
        {
            id: '#pencil-2',
            offset: 490,
            duration: 50,
            css: {
                top: '650px',
                left: '300px',
            }
        },
        {
            id: '#tablet',
            offset: 550,
            duration: 60,
            css: {
                top: '500px',
                left: '10px',
            }
        },
        {
            id: '#usb',
            offset: 610,
            duration: 90,
            css: {
                top: '705px',
                left: '385px',
            }
        },
    ];

    elems.forEach(function(config, idx) {
        var tween = new window.TimelineMax()
            .to(config.id, config.time || .5, config.css);

        var scene = new window.ScrollMagic.Scene({
            offset: config.offset,
            duration: config.duration,
            triggerElement: '#intro-scene'
        }).setTween(tween)
        // .addIndicators({name: "timeline" + idx})
        .addTo(controller);
    });
};



// WEBPACK FOOTER //
// ./resources/js/components/intro.js